<template>
    <div>
      <div class="row">
        <div class="col">
          <h2>
            {{ $t("summary.title") }}
          </h2>
        </div>
        <div class="col text-right">
          <img id='companyImage' class="mb-3" :src="logoUrl">
        </div>
      </div>
    <hr>
    <div class="container">
      <div class="row ">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.origin") }}:</strong><br>
            {{ fromPlace.description || 'Cancun Airport'}}
          </p>
      </div>
      <div class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.destination") }}:</strong><br>
            {{ toPlace.description || 'Cancun Airport'}}
          </p>
      </div>
      <div class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.adults") }}:</strong><br>
            {{ form.adults }}
          </p>
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.kids") }}:</strong><br>
            {{ form.kids }}
          </p>
      </div>
      <div class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.serviceType") }}:</strong><br>
            {{ info.serviceType }}
          </p>
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.tripType") }}:</strong><br>
            {{ info.tripType }}
          </p>
      </div>
      <div v-if="form.coupon" class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.coupon") }}:</strong><br>
            {{ form.coupon }}
            <br>
            {{ couponDescription }}
          </p>
      </div>
    </div>
    <hr>
    <h2>{{ $t("summary.schedules") }}</h2>
    <div v-if="form.tripType === 'oneWay'">
      <div v-if="tripType === TripTypes.PlaceAirport">
        <DateInformation
          :name="$t('summary.departure')"
          :from="fromPlace.description"
          :to="toPlace.description"
          :date="formDates.departureDate"
          :hours="formDates.departureHours"
          :minutes="formDates.departureMinutes"
          :pickUp="formDates.pickUpDate != null"
          :flight="form.departureFlightNumber"
          :airline="form.departureAirline"
          :extras="form.extras"
          >
        </DateInformation>
      </div>
      <div v-if="tripType === TripTypes.AirportPlace">
        <DateInformation
          :name="$t('summary.arrival')"
          :from="fromPlace.description"
          :to="toPlace.description"
          :date="formDates.arrivalDate"
          :hours="formDates.arrivalHours"
          :minutes="formDates.arrivalMinutes"
          :flight="form.arrivalFlightNumber"
          :airline="form.arrivalAirline"
          :extras="form.extras"
          >
        </DateInformation>
      </div>
    </div>
    <div v-if="form.tripType === 'roundTrip'">
      <div v-if="tripType === TripTypes.PlaceAirport">
        <DateInformation
          :name="$t('summary.departure')"
          :from="fromPlace.description"
          :to="toPlace.description"
          :date="formDates.departureDate"
          :hours="formDates.departureHours"
          :minutes="formDates.departureMinutes"
          :pickUp="formDates.pickUpDate != null"
          :flight="form.departureFlightNumber"
          :airline="form.departureAirline"
          :extras="form.extras.filter((extra) => extra.trip == 1)"
          >
        </DateInformation>
        <DateInformation
          :name="$t('summary.arrival')"
          :from="toPlace.description"
          :to="fromPlace.description"
          :date="formDates.arrivalDate"
          :hours="formDates.arrivalHours"
          :minutes="formDates.arrivalMinutes"
          :flight="form.arrivalFlightNumber"
          :airline="form.arrivalAirline"
          :extras="form.extras.filter((extra) => extra.trip == 2)"
          >
        </DateInformation>
      </div>
      <div v-if="tripType === TripTypes.AirportPlace">
        <DateInformation
          :name="$t('summary.arrival')"
          :from="fromPlace.description"
          :to="toPlace.description"
          :date="formDates.arrivalDate"
          :hours="formDates.arrivalHours"
          :minutes="formDates.arrivalMinutes"
          :flight="form.arrivalFlightNumber"
          :airline="form.arrivalAirline"
          :extras="form.extras.filter((extra) => extra.trip == 1)"
          >
        </DateInformation>
        <DateInformation
          :name="$t('summary.departure')"
          :from="toPlace.description"
          :to="fromPlace.description"
          :date="formDates.departureDate"
          :hours="formDates.departureHours"
          :minutes="formDates.departureMinutes"
          :pickUp="formDates.pickUpDate != null"
          :flight="form.departureFlightNumber"
          :airline="form.departureAirline"
          :extras="form.extras.filter((extra) => extra.trip == 2)"
          >
        </DateInformation>
      </div>
    </div>
    <div v-if="tripType === TripTypes.PlacePlace">
      <DateInformation
        :name="$t('summary.pickup')"
        :from="fromPlace.description"
        :to="toPlace.description"
        :date="formDates.originDate"
        :hours="formDates.originHours"
        :minutes="formDates.originMinutes"
        :placeToPlace="true"
        :extras="form.extras.filter((extra) => extra.trip == 1)"
        >
      </DateInformation>
      <DateInformation
        v-if="form.tripType === 'roundTrip'"
        name="Drop Off"
        :from="toPlace.description"
        :to="fromPlace.description"
        :date="formDates.destinationDate"
        :hours="formDates.destinationHours"
        :minutes="formDates.destinationMinutes"
        :placeToPlace="true"
        :extras="form.extras.filter((extra) => extra.trip == 2)"
        >
      </DateInformation>
    </div>
    <hr>
    <h3>{{ $t("summary.clientData") }}</h3>
    <div class="container">
      <div class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.name") }}:</strong><br>
            {{firstName}} {{lastName}}
          </p>
      </div>
      <div class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.email") }}:</strong><br>
            {{email}}
          </p>
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.phone") }}:</strong><br>
            {{phone}}
          </p>
      </div>
      <div class="row">
          <p class="data-row col border p-2 m-0">
            <strong>{{ $t("summary.notes") }}:</strong><br>
            {{notes}}
          </p>
      </div>
    </div>
    <hr>
    <h2>{{ $t("summary.totals") }}</h2>
		<div v-if="loading" class="text-center">
		  <div class="spinner-border text-center text-primary" style="width: 3rem; height: 3rem;" role="status">
		    <span class="sr-only">{{ $t("summary.loading") }}</span>
		  </div>
		</div>
    <div v-else>
      <div class="summary mb-2 container">
          <div class="row text-right">
            <div class="col-6 h5">{{ $t("summary.trip") }}:</div>
            <div class="col-6 h5">${{prices.transferSubtotal}} {{form.currency}}</div>
          </div>
          <div class="row text-right">
            <div class="col-6 h5">{{ $t("summary.extras") }}:</div>
            <div class="col-6 h5">${{prices.extrasSubtotal}} {{form.currency}}</div>
          </div>
          <div class="row text-right">
            <div class="col-6 h5">{{ $t("summary.taxes") }}:</div>
            <div class="col-6 h5">${{prices.taxes}} {{form.currency}}</div>
          </div>
          <div class="row text-right border-top border-bottom">
            <div class="col-6 h2">{{ $t("summary.total") }}:</div>
            <div class="col-6 h2">${{prices.total}} {{form.currency}}</div>
          </div>
      </div>
    	<h3 class="text-center"><strong>{{ $t("summary.selectPayment") }}:</strong></h3>
      <p class="text-center text-danger" v-if="errors.has('payment')">{{ $t("summary.choosePayment") }}</p>
      <div class="row btn-selection no-gutters">
          <input v-validate="'required'" type="hidden" name="payment" v-model="paymentMethod" />
          <button v-for="payment in settings.paymentTypes" type="button" class="btn" :class="[ paymentMethod==payment.code?'active btn-primary':'btn-default', {'btn-force-danger': errors.has('payment')} ]" @click="paymentMethod = payment.code">
                {{$i18n.locale == 'es' ? paymentMethodsEs[payment.code] : paymentMethodsEn[payment.code]}}
                <font-awesome-icon class="check" icon="check" />
          </button>
      </div>
      <br>
      <Navigation :onSubmit="onSubmit"></Navigation>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import {mapStateInfo, mapStateInfoVal, mapMutationsInfo, dynamicFormSetGet} from '../js/InformationStoreInfo.js'
import {TripTypes} from '../js/constants.js'
import Datepicker from 'vuejs-datepicker';
import Navigation from './Navigation.vue'
import DateInformation from './DateInformation.vue'
import Utils from '../js/Utils'

export default {
  name: 'Summary',
  components: {
    Datepicker,
    Navigation,
    DateInformation
  },
  data: () => {
    return {
      loading: true,
      prices: {},
      paymentMethodsEs : {
        'paypal':'PayPal',
        'at-arrival':'A la llegada',
        'card':'Tarjeta Credito/Debito',
        'stripe':'Tarjeta Credito/Debito'
      },
      paymentMethodsEn : {
        'paypal':'PayPal',
        'at-arrival':'At Arrival',
        'card':'Credit/Debit Card',
        'stripe':'Credit/Debit Card'
      },
      TripTypes: TripTypes
    }
  },
  computed: {
    ...mapState(['info', 'fromPlace','toPlace','formDates', 'tripType','couponDescription']),
    ...mapState(mapStateInfo),
    ...mapState(mapStateInfoVal),
    ...mapGetters(['logoUrl']),
    ...dynamicFormSetGet()
  },
  mounted() {
    this.formatFormExtras();
    this.$http.post('prices/totals', {...this.form}, {emulateJSON: true})
      .then((res) => {
        this.loading = false;
        this.prices = res.body;
      });
  },
  methods: {
    ...mapMutations(mapMutationsInfo),
    ...mapActions(['formatFormExtras']),
    onSubmit() {
      if (this.form.paymentMethod) {
        this.submitForm();
      } else {
        this.$alertify.alert("Required fileds", "Please choose a payment method");
      }
    },
    tryGetChannel() {
      let channel = null;
      if (window.URL && window.URL.prototype) {
        const url = new URL(window.location);
        channel = url.searchParams ? url.searchParams.get('channel') : null;
      }

      if (document.referrer && document.referrer.split) {
        const searchs = document.referrer.split('?')
        const search = searchs.length >= 2 ? searchs[1] : '';
        const matchs = search.match(/channel=(.*)/);
        const match = matchs && matchs.length >= 2 ? matchs[1] : null;
        channel = match || channel;
      }
      return channel;
    },
    submitForm() {
      let form = {...this.form}

      form.originUrl = window.location && window.location.origin;
      form.clientLang = this.$i18n.locale
      form.channel = this.tryGetChannel();

      if (this.arrivalDate != null) {
        form.arrivalFlightTime = this.formateDatetime(this.arrivalDate, this.arrivalHours, this.arrivalMinutes)
      }
      if (this.departureDate) {
        form.departureFlightTime = this.formateDatetime(this.departureDate, this.departureHours, this.departureMinutes);
      }

      if (this.originDate) {
        form.originPickUpTime = this.formateDatetime(this.originDate, this.originHours, this.originMinutes);
      }

      if (this.destinationDate) {
        form.destinationPickUpTime = this.formateDatetime(this.destinationDate, this.destinationHours, this.destinationMinutes);
      }

      if (this.pickUpDate) {
          form.pickupTime = this.formateDatetime(this.pickUpDate, this.pickUpHours, this.pickUpMinutes);
      }

      return this.reservationCreate(form);
    },
    reservationCreate(form) {
      this.loading = true;
      this.$http.post('reservations/create', form, {emulateJSON: true})
        .then((res) => {
          if (res.body && res.body.success) {
            this.voucherToken(res.body.token);
            if (form.paymentMethod === 'at-arrival') {
              this.postAtArrival();
            } else if (form.paymentMethod === 'paypal') {
              this.postPayPal(res.body);
            } else if (form.paymentMethod === 'card') {
              this.postCard(res.body);
            } else if (form.paymentMethod === 'stripe') {
              this.postStripe(res.body);
            }
          } else {
            this.loading = false;
          }
        });
    },
    postAtArrival() {
      this.$router.push('success');
    },
    postPayPal(body) {
      if( window !== window.top ){
        window.top.location.replace(body.redirect);
      }else{
        window.location.replace(body.redirect);
      }
    },
    postCard(body) {
      this.$router.push({path: 'paypal', query: {token: body.token}});
    },
    postStripe(body) {
      this.$router.push({path: 'stripe-checkout', query: {token: body.token}});
    },
    formateDatetime: Utils.formateDatetime.bind(Utils),
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #companyImage{
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 1;
    transform: rotate(-15deg);
  }
  .data-row p{
    margin: 0;
  }
  .container .row:not(:last-child) .col{
    border-bottom: 0 !important;
  }
  .btn-selection button.active svg.check{
    display: block;
  }
  .btn-selection button svg.check{
    display:none;
    position: absolute;
    top: 5px;
    right:5px;
    border-radius: 100%;
    padding: 2px;
  }
  .btn-selection button.active{
    width: 32%;
    height: 100px;
  }
  .btn-selection{
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .btn-selection button input{
    visibility: hidden;
    position: absolute;
  }
  .btn-selection button{
    border-width: 3px;
    border-style: solid;
    /*white-space:nowrap;*/
    font-weight: bold;
    position: relative;
    width: 33%;
    line-height: 18px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 .5px !important;
  }
</style>
